import { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import PageMenu from 'components/blocks/PageMenu/PageMenu'
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import { useParams } from 'react-router-dom';
import Loader from 'components/blocks/Loader/Loader';
import useDecode from 'hooks/useDecode';
import PrestacionCUME from './PrestacionCUME';
import useGetPrestacionCUMEByID from 'services/record/PrestacionCUME/useGetPrestacionCUMEByID';
interface Params {
    idprestacion: string;
    idform: string;
}


const HistorialPrestacionCUME = () => {
    const decoded = useDecode("token");
    const [data, setData] = useState(null);
    const navigate = useNavigate()
    const { dataGetPrestacionCUMEByID, errorGetPrestacionCUMEByID, getPrestacionCUMEByID, loadingGetPrestacionCUMEByID, successGetPrestacionCUMEByID } = useGetPrestacionCUMEByID();
    const { idprestacion, idform } = useParams<Record<string, string>>();


    useEffect(() => {
        const actualUrl = window.location.href;
        if (!actualUrl.includes('/mis-gestiones/formularios')) {
            const userId = decoded.extension_id;
            const prestacionId = idprestacion.split('_')[1];
            const formId = idform;

            getPrestacionCUMEByID(userId, prestacionId, formId, setData);
        }
    }, []);

    return (
        <div>
            <PageMenu title={'Prestación económica por cuidado de menores afectados por cáncer u otra enfermedad grave'}>

                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>


            {
                loadingGetPrestacionCUMEByID ?
                    <Loader activeLoader={true} label="Cargando Formulario"></Loader>
                    :
                    <PrestacionCUME dataUser={data} info={false} />
            }




        </div>
    )
}

export default HistorialPrestacionCUME